import React from 'react';
import { Link } from 'react-router-dom';
import MarketingShell from '../../components/MarketingShell';
import jobs from '../../data/marketing/jobs.json';

const openJobs = jobs.filter((job) => !job.isDraft);

export default function CareersPage() {
  return (
    <MarketingShell
      title="Careers"
      description="Help build tools that find grants, savings, and AI upgrades for growing companies."
    >
      <ul className="divide-y divide-gray-100 rounded-xl border border-gray-100 bg-white">
        {openJobs.map((job) => (
          <li key={job.slug}>
            <Link to={`/jobs/${job.slug}`} className="block px-6 py-5 hover:bg-gray-50 transition-colors">
              <p className="text-sm font-semibold text-gray-900">{job.name}</p>
              <p className="mt-1 text-sm text-gray-500">
                {[job.location, job.employmentBasis].filter(Boolean).join(' · ')}
              </p>
            </Link>
          </li>
        ))}
      </ul>
    </MarketingShell>
  );
}
